export default "__VITE_ASSET__7664c821__"